<template>
  <el-container class="f-h">
    <el-row v-if="!entity" type="flex" justify="center" align="middle" class="f-h f-w center">
      <div v-if="!errMsg">
        <img v-if="theme && theme.loadingImgFile" :src="theme.loadingImgFile" />
        <h2>正在加载，请稍后…</h2>
      </div>
      <div v-else>
        <img v-if="theme && theme.errImgFile" :src="theme.errImgFile" />
        <h2 class="danger">{{ errMsg }}</h2>
      </div>
    </el-row>
    <editor ref="editor" v-if="entity" :visible.sync="showEditor" :main="entity" :readonly="readonly" @submited="close" @close="close" />
  </el-container>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      editor: () => import("@/components/mrMain/dlgEditor"),
    },
    data() {
      return {
        showEditor: false,
        entity: null,
        errMsg: null,
        readonly: false,
        treatment: null,
        mrMainId: null,
        condition: {
          opNo: null,
        },
      };
    },
    computed: {
      ...mapGetters(["token", "theme", "user", "Enum"]),
    },
    mounted() {
      if (!this.token) {
        this.showErr("当前用户尚未登录！");
        return;
      }
      this.entity = {};
      this.init();
    },
    methods: {
      async init() {
        this.errMsg = null;
        this.readonly = !!this.$route.query.readonly;
        try {
          let opNo = this.$route.query.op;
          if (!opNo) {
            throw "缺少就诊号参数！";
          }
          let op = await this.$api.getOp(opNo);
          if (!op) {
            throw "未找到对应的就诊记录！";
          }
          this.generate(op);
          try {
            // 切换到病历所在科室
            let user = this.$store.getters.user;
            user.deptCode = op.deptCode;
            user.deptName = this.$utils.Dict.text(op.deptCode, "Dept");
            this.$store.commit("user", user);
          } catch (error) {
            console.log(error);
          }
        } catch (error) {
          this.$utils.log(error);
          this.showErr("未找到对应的就诊记录！");
        }
      },
      async setRecordId(opNo) {
        this.condition.opNo = opNo;
        this.$api.Treatment.query(this.condition).then((res) => {
          let treatment = res.items[0];
          treatment.opRecordId = this.mrMainId;
          this.$api.Treatment.save(treatment);
        });
      },
      async opSync(opNo) {
        try {
          this.syncing = true;
          let para = {
            opNo: opNo,
          };

          let msg = await this.$api.Treatment.sync(para);
          this.$notify({
            title: "数据同步结果",
            message: msg,
            type: "warning",
            duration: 0,
          });

          this.condition.pageIndexOnView = 1;
          this.setRecordId(opNo);
          //this.query();
        } catch (err) {
          this.$message.error(err);
        } finally {
          this.syncing = false;
        }
      },
      async generate(op) {
        let mains = (await this.$api.MrMain.query({ nos: op.opNo })).items;
        if (!mains[0]) {
          if (this.readonly) {
            this.showErr("当前就诊号尚未书写病历！");
          } else {
            let main = await this.$api.MrMain.save({
              opNo: op.opNo,
              patientCode: op.patientCode,
              patientName: op.patientName,
              patientGender: op.patientGender,
              patientAge: op.patientAge,
              deptCode: op.deptCode,
              doctorCode: op.doctorCode,
              doctorName: op.doctorName,
              diagnosis: op.diagnosis,
              opTime: this.$utils.Fmt.datetime(op.takingDate),
              submitTime: this.$utils.Dt.now(),
              submitUserCode: this.user.id,
              submitUserName: this.user.name,
              qcState: this.Enum.MrQCState.未提交,
              nos: JSON.stringify([op.opNo]),
              ifArchived: false,
              editingUserCode: this.user.code,
              editingUserName: this.user.name,
            });
            this.mrMainId = main.id;
            if (main.opNo) {
              this.opSync(main.opNo);
            }
            this.edit(main);
          }
        } else {
          if (this.readonly) {
            this.view(mains[0]);
          } else {
            this.edit(mains[0]);
          }
        }
      },
      async edit(row) {
        this.readonly = false;
        try {
          this.entity = await this.$api.MrMain.lock(row.id);
          this.$utils.Obj.propertyCopy(this.entity, row);
        } catch (error) {
          this.showErr(error);
          return;
        }
        this.showEditor = true;
      },
      view(row) {
        this.readonly = true;
        this.entity = row;
        this.showEditor = true;
      },
      close() {
        this.$nextTick(() => {
          this.$router.replace({ name: "mrMain" });
        });
      },
      showErr(err) {
        this.$message.error(err);
        this.errMsg = err;
      },
    },
  };
</script>

<!-- <style scoped>
  .h-background {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%; /**宽高100%是为了图片铺满屏幕 */
    z-index: -1;
    position: absolute;
  }
  .h-main {
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    margin-top: -100px;
  }
  .h-load-img {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    width: 175px;
    height: 175px;
  }
  .h-load-img img {
    width: 100%;
    height: 100%;
  }
  .h-load-text {
    margin-top: 15px;
    font-size: 18px;
    font-weight: bold;
    color: #362108;
  }
</style> -->
